import { type IAdvancedSearchFieldProps } from "./AdvancedSearchCriteria.js";
import { type IOptionObject } from "./CheckboxMultiSelect/Option.js";
import CheckboxSelect from "./CheckboxSelect.js";

/**
 * Two input fields for genomes to construct a variant profile filter.
 * First field contains all genomes where the variant must be present.
 * Second field contains all genomes where the variant must be absent.
 */
export default function AdvancedSearchStringListSelect(props: IAdvancedSearchFieldProps) {
  const itemType = "genome";
  const itemTypePlural: string = itemType + "s";

  // FIXME: Propose a better name for "value" properties?
  const value1 = (props.filterOperation.value as string[]) || [];
  const value2 = (props.filterOperation.value2 as string[]) || [];

  const searchAttributes = props.field.searchAttribute.values as unknown as IOptionObject[];

  // create the two value lists for the multi selects which
  // provide only genomes that have not been assigned to one of each other yet.
  // so we have only mutually exclusive criteria
  const optionsPresent = searchAttributes.filter((v) => value2.findIndex((x) => v.key === x) < 0);
  //const optionsAbsent = searchAttributes.filter((v) => value1.findIndex((x) => v.key === x) < 0);

  // we need an array of complete IKeyLabels also for the selected values
  const selectedOptionsPresent = searchAttributes.filter((x) => value1.findIndex((v) => x.key === v) !== -1);
  //const selectedOptionsAbsent = searchAttributes.filter((x) => value2.findIndex((v) => x.key === v) !== -1);

  // TODO: Probably a better idea is to have a unique placeholder property for CheckboxSelect
  //       which is a callback with the numerical quantity as parameter instead of having multiple placeholders?
  const totalNumberOfOptions = searchAttributes.length;
  const manySelectedFormatPresent = `%d ${itemType}${selectedOptionsPresent.length > 1 ? "s" : ""} selected`;
  // const manySelectedFormatAbsent = `%d %{itemType}${selectedOptionsAbsent.length > 1 ? "s" : ""} selected`;

  return (
    <div
      style={{
        flex: 1,
        display: "flex",
        flexDirection: props.verticalLayout ? "column" : "row",
        rowGap: props.verticalLayout ? 5 : null,
        columnGap: props.verticalLayout ? null : 5,
      }}
    >
      <span> At least one must be in </span>
      <CheckboxSelect
        uniqueKey={"in"}
        showFilter={optionsPresent.length > 1}
        showSelectAll={true}
        value={selectedOptionsPresent}
        options={optionsPresent}
        placeholder={optionsPresent.length !== 0 ? `Select ${itemTypePlural}` : `No ${itemTypePlural} left to select`}
        numberDisplayed={1}
        valueKey="key"
        labelKey="label"
        onChange={(option: IOptionObject[]) => {
          props.onChangeState({ value: option.map((innerOption: IOptionObject) => innerOption.key) });
        }}
        allSelectedPlaceholder={
          totalNumberOfOptions === selectedOptionsPresent.length
            ? `All %d ${itemTypePlural} selected`
            : manySelectedFormatPresent
        }
        manySelectedPlaceholder={manySelectedFormatPresent}
        defaultFocusFilter={true}
      />
    </div>
  );
}
